<template>
	<v-container>
		<Snackbar v-if="errored" msg="Error from Server" />
		<Snackbar v-if="deleted" msg="Operation Successfull" />	
		<v-dialog v-model="create" width="75%">
			<v-card>
				<NewProject ref="createDialog"/>
			</v-card>
		</v-dialog>
		<v-dialog v-model="edit" width="75%">
			<v-card>
				<EditProject :editId="editId" ref="editDialog"/>
			</v-card>
		</v-dialog>		
		<v-card-title>
			Projects
			<v-spacer></v-spacer>
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
			></v-text-field>
			<v-btn
				color="success"
				class="ml-8"
				@click="create = !create"
			>
				New
				<v-icon class="ms-2">
					mdi-plus
				</v-icon>
			</v-btn>			
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="projects"
			:search="search"
			class="elevation-1"
		>
			<template v-slot:[`item.actions`]="{ item }">
				<v-tooltip left>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="primary"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="(editId = item._id) && (edit = !edit)"
						>
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span> Edit </span>
				</v-tooltip>                
				<v-tooltip right>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="error"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="confirmDelete() && deleteProject(item)"
						>
							<v-icon>mdi-delete</v-icon>
						</v-btn>
					</template>
					<span> Delete </span>
				</v-tooltip>
			</template>
		</v-data-table>
	</v-container>
</template>

<script>
import axios from '../../plugins/axios'
import Snackbar from '@/components/Snackbar.vue'
import NewProject from '../Projects/New.vue'
import EditProject from '../Projects/Edit.vue'

export default {
  name: 'Projects',
	components: {
		Snackbar,
		NewProject,
		EditProject
	},	
  data: () => ({
    loading: true,
    errored: false,
    deleted: false,
		create: false,
		edit: false,
		editId: null,		
    projects: [],
		search: '',
		headers: [
			{ text: 'Title', value: 'name', width: '20%', align: 'start' },
			{ text: 'Description', value: 'description', width: '40%', align: 'start' },
			{ text: 'Link', value: 'link', width: '30%', align: 'start' },
			{ text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '10%' }			
		]
  }),

	mounted() {
		this.getProjects();
	},

	methods: {
		getProjects(){
			axios
			.get(`/project/`)
			.then(res => {
				this.projects = res.data.data;
			})
			.catch(err => {
				console.error("axios err", err);
				this.errored = true;
			})
			.finally(() => this.loading = false);
		},

		confirmDelete(){
			return confirm("Are you sure you want to delete this project?");
		},

		deleteProject(project){
			axios
			.delete(`/project/`, {data: {_id: project._id}})
			.then(() => {
        this.deleted = true
				this.getProjects();
			})
			.catch(err => {
				console.error("error", err);
				this.errored = true;
			})
			.finally(() => {
				this.loading = false;
			});
		}
	},
	watch: {
		create: function(){
			if(!this.create){
				this.getProjects();
				this.$refs.createDialog.reset();
			}
		},

		edit: function(){
			if(!this.edit){
				this.getProjects();
				this.editId = null;
				this.$refs.editDialog.reset();
			}
		}
	}
}
</script>

<style>

</style>